import React, { Component } from 'react';
export default class EventTimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
    }
    timeCount(totalSec){
        let days,hours,mins,secs = 0
        secs = totalSec % 60 | 0
        let totalMins = totalSec/60 | 0
        mins = totalMins % 60 | 0
        let totalHours = totalMins/60 | 0
        hours = totalHours % 24 | 0
        let totalDays = totalHours/24 | 0
        days = totalDays % 1 | 0
        return {
            "days":days,
            "hours":hours,
            "mins":mins,
            "secs":secs
        }
    }
    render() {
        let data = this.timeCount(parseInt(this.props.duration))
        return (
            <div className="event-timmer">
                <span className="l1-txt3">{data.days} <span>Days</span></span>
                <span className="l1-txt3">{data.hours} <span>Hours</span></span>
                <span className="l1-txt3">{data.mins} <span>Minutes</span></span>
                <span className="l1-txt3">{data.secs} <span>Seconds</span></span>
            </div>
        )
    }
}
